import { createRouter, createWebHashHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import TrackingPage from '../views/TrackingPage.vue'
import PartnersPage from '../views/PartnersPage.vue'
import CourierPage from '../views/CouriersPage.vue'
import CareerPage from '../views/CareersPage.vue'
import SupportPage from '../views/SupportPage.vue'
import AboutPage from '../views/AboutPage.vue'
import CopyrightPage from '../views/CopyrightPage.vue'
import PrivacyPolicyPage from '../views/PrivacyPolicyPage.vue'
import EmailOptOut from '../views/EmailOptOutPage.vue'

import HomePageFR from '../views/fr/HomePage.vue'
import TrackingPageFR from '../views/fr/TrackingPage.vue'
import PartnersPageFR from '../views/fr/PartnersPage.vue'
import CourierPageFR from '../views/fr/CouriersPage.vue'
import CareerPageFR from '../views/fr/CareersPage.vue'
import SupportPageFR from '../views/fr/SupportPage.vue'
import AboutPageFR from '../views/fr/AboutPage.vue'
import CopyrightPageFR from '../views/fr/CopyrightPage.vue'
import PrivacyPolicyPageFR from '../views/fr/PrivacyPolicyPage.vue'
import EmailOptOutFR from '../views/fr/EmailOptOutPage.vue'


const routes = [{
        path: '/',
        name: 'home-page',
        component: HomePage
    },
    {
        path: '/track-your-shipment',
        name: 'tracking-page',
        component: TrackingPage
    },
    {
        path: '/partners',
        name: 'partners-page',
        component: PartnersPage
    },
    {
        path: '/couriers',
        name: 'courier-page',
        component: CourierPage
    },
    {
        path: '/careers',
        name: 'career-page',
        component: CareerPage
    },
    {
        path: '/support',
        name: 'support-page',
        component: SupportPage
    },
    {
        path: '/about-postmedia',
        name: 'about-page',
        component: AboutPage
    },
    {
        path: '/copyright',
        name: 'copyright-page',
        component: CopyrightPage
    }, {
        path: '/google-apps-policy',
        name: 'privacy-policy-page',
        component: PrivacyPolicyPage
    }, {
        path: '/email-opt-out/:accountid',
        name: 'email-opt-out',
        component: EmailOptOut
    },{
        path: '/fr/google-apps-policy',
        name: 'fr-privacy-policy-page',
        component: PrivacyPolicyPageFR
    }, {
        path: '/fr',
        name: 'fr-home-page',
        component: HomePageFR
    },
    {
        path: '/fr/track-your-shipment',
        name: 'fr-tracking-page',
        component: TrackingPageFR
    },
    {
        path: '/fr/partners',
        name: 'fr-partners-page',
        component: PartnersPageFR
    },
    {
        path: '/fr/couriers',
        name: 'fr-courier-page',
        component: CourierPageFR
    }, 
    {
        path: '/fr/careers',
        name: 'fr-career-page',
        component: CareerPageFR
    },
    {
        path: '/fr/support',
        name: 'fr-support-page',
        component: SupportPageFR
    },
    {
        path: '/fr/about-postmedia',
        name: 'fr-about-page',
        component: AboutPageFR
    },
    {
        path: '/fr/copyright',
        name: 'fr-copyright-page',
        component: CopyrightPageFR
    },{
        path: '/fr/email-opt-out/:accountid',
        name: 'fr-email-opt-out',
        component: EmailOptOutFR
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router